// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction
import { postSFData } from 'public/Constant.js';
$w.onReady(function () {});

export function submitSFForm_click(event) {
	postSFData()
}

